export default __webpack_public_path__ + "static/media/freedom.b8c52737.png";